export default __webpack_public_path__ + "static/media/calendar-blue.42c57509.svg";